import * as types from '../constants/actionTypes'

const initialState = {
  isAuth: false,
  showDuo: false,
  sigRequest: null,
  user: null,
}

export const session = (state = initialState, action) => {
  switch (action.type) {
    case types.CreateSession:
      const { user } = action
      return {
        ...state,
        user,
        isAuth: true,
      }
    case types.ShowDuo:
      const { sigRequest } = action
      return {
        ...state,
        sigRequest,
        showDuo: true,
      }
    case types.HideDuo:
      return {
        ...state,
        sigRequest: null,
        showDuo: false,
      }
    default:
      return state
  }
}

// We have to reference user.roles until we either get back a list
// of badges from the REST endpoint for signing in or we re-fetch
// the user via GraphQL
export const selectCurrentUserBadges = (state) => {
  return (
    state.session.user &&
    state.session.user.roles.map((role) => role.toUpperCase())
  )
}
